export default __webpack_public_path__ + "static/media/broker.035c7064.svg";